import { Pipe, PipeTransform } from '@angular/core';
import { quantityPrettyfier } from '@sparte/utils';

@Pipe({
  name: 'prettyQuantity',
})
export class PrettyQuantityPipe implements PipeTransform {
  transform(value: number): string {
    return quantityPrettyfier(value);
  }
}
